export const pad = (n: string, len: number) => {
  return (new Array(len + 1).join("0") + n).slice(-len);
};
